import { AfterContentInit, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LocationModel, LocationFacebookTokenPair, ReviewModel } from '@models/index';
import { FacebookFacadeService } from '@services/facebook/facebook-facade.service';
import { take, filter, debounceTime } from 'rxjs/operators';
import { ReviewsFacadeService } from '@services/reviews/reviews-facade.service';
import { RouterFacadeService } from '@services/router-facade.service';
import { Observable } from 'rxjs';
import { FacebookServices } from '@services/facebook/facebook.service';
import { FacebookTokenTypes } from '@enums/facebookTokenTypes.enum';

@Component({
  selector: 'share-review-modal',
  templateUrl: './share-review-modal.component.html'
})
export class ShareReviewModal implements AfterContentInit {
  @Input() location?: LocationModel = null;
  @Input() review?: ReviewModel = null;

  sharingError$ = this.FacebookFacadeService.getError$();
  shareReviewSuccess$ = this.FacebookFacadeService.getShareReviewSuccess$();
  locationFacebookTokenPairs: LocationFacebookTokenPair[] = null;

  constructor (
    private activeModal: NgbActiveModal,
    private FacebookFacadeService: FacebookFacadeService,
    private routerFacadeService: RouterFacadeService,
  ) {}

  ngAfterContentInit() {
    this.FacebookFacadeService.searchFacebookPages(this.location.id, FacebookTokenTypes.SOCIAL_SHARING);
    
    this.FacebookFacadeService.getFacebookPages$(this.location.id).pipe(
      filter(pairs => pairs.some(pair => pair.locationToken.locationId == this.location.id)),
    ).subscribe(pairs => {
      // this.locationFacebookTokenPairs = pairs;
    });

    this.FacebookFacadeService.getSelectedTokens$().subscribe(token => this.locationFacebookTokenPairs = token)
  }

  dismiss() {
    this.FacebookFacadeService.reset();
    this.activeModal.dismiss();
  }

  gotoSharing() {
    this.routerFacadeService.gotoSharing$();
    this.activeModal.dismiss();
  }

  shareReviewToPage(review: ReviewModel, page: LocationFacebookTokenPair) {
    this.FacebookFacadeService.shareReview({
      locationFacebookTokenPair: page,
      reviewId: review.reviewExternId
    });
  }

  dismissError() {
    this.FacebookFacadeService.dismissError();
  }
}
